// The data alarms page's filters, kept apart from the page so the router can read the URL without loading the console
// chunk.
export type DataAlarmState = "open" | "closed" | "all";
export type DataAlarmFilter = { state: DataAlarmState; type_id?: string; org_id?: string };

/** Reads the data alarms page's filters from the URL. */
export function parseDataAlarmFilter(s: Record<string, unknown>): Partial<DataAlarmFilter> {
  const out: Partial<DataAlarmFilter> = {};
  if (s.state === "open" || s.state === "closed" || s.state === "all") out.state = s.state;
  if (typeof s.type_id === "string" && /^[a-z0-9_]{1,40}(\.[a-z0-9_]{1,40})?$/.test(s.type_id)) out.type_id = s.type_id;
  if (typeof s.org_id === "string" && /^[0-9a-f-]{36}$/i.test(s.org_id)) out.org_id = s.org_id.toLowerCase();
  return out;
}
